export const enum ContentType {
  STRING = 'string',
  PRODUCT_IDS = 'productIds',
  SHARED_PRODUCT_IDS = 'sharedProductIds',
  BANNERS = 'banners',
  SHARED_BANNERS = 'sharedBanners',
}
